/* eslint-disable @typescript-eslint/naming-convention */
export const PURGE_CUSTOMERS = "@CUSTOMERS/PURGE_CUSTOMERS";
export type PURGE_CUSTOMERS = typeof PURGE_CUSTOMERS;

export const SET_CUSTOMER = "@CUSTOMERS/SET_CUSTOMER";
export type SET_CUSTOMER = typeof SET_CUSTOMER;
